import request from '#/utils/request';
import useSWR from 'swr';
import { ResponseObject } from '../interfaces';

export interface PriceInfo {
  symbol: string;
  price: string;
}

/**
 * usePriceList
 */
export default function usePriceList(symbols?: string[]) {
  return useSWR(
    symbols && symbols.length > 0 ? ['/api/v1/price/list', symbols] : null,
    ([url, symbols]) =>
      request.post<ResponseObject<PriceInfo[]>>(url, { symbols }),
    {
      refreshInterval: 12_000,
      keepPreviousData: true,
    }
  );
}
